import { render, staticRenderFns } from "./BasePhone.vue?vue&type=template&id=5c0a5297&scoped=true"
import script from "./BasePhone.vue?vue&type=script&lang=js"
export * from "./BasePhone.vue?vue&type=script&lang=js"
import style0 from "./BasePhone.vue?vue&type=style&index=0&id=5c0a5297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a5297",
  null
  
)

export default component.exports